module.exports = __webpack_public_path__ + "img/location-singapore-4.0bcdf335.jpg";